import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from "react-router-dom";
import { DataTable } from '../../../components/DataTable/DataTable';
import { useDataTable } from '../../../components/DataTable/useDataTable';
import { UsuarioService } from '../../../services/UsuarioService';
import { Chip } from '@material-ui/core';

const Usuarios = () => {
    const history = useHistory();
    const tableState = useDataTable({ initialLimit: 15 });
    
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchData = useCallback(async () => {
        setLoading(true);
        const rows = await UsuarioService.obtenerLista(
            tableState.page,
            tableState.limit,
            tableState.filters,
            tableState.orderBy,
            tableState.order
        );
        setData(rows);
        setLoading(false);
    }, [tableState.page, tableState.limit, tableState.filters, tableState.orderBy, tableState.order]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const hasMore = data.length === tableState.limit; 

    const columns = [
        { id: 'email', label: 'Correo', filter: true },
        { id: 'nombre', label: 'Nombre', filter: true },
        { id: 'apellido_paterno', label: 'Apellido Paterno', filter: true },
        { id: 'apellido_materno', label: 'Apellido Materno', filter: true },
        { id: 'sucursal_nombre', label: 'Sucursal', filter: true },
        { id: 'rol_nombre', label: 'Rol', filter: true },
        { 
            id: 'estado_situacion', 
            label: 'Estado', 
            filter: true,
            render: (row) => {
                const isActive = row.estado_situacion === 'Activo';
                return (
                    <Chip
                        size="small"
                        label={row.estado_situacion || 'N/A'}
                        style={{
                            backgroundColor: isActive ? '#e8f5e9' : '#ffebee',
                            color: isActive ? '#2e7d32' : '#c62828',
                            fontWeight: 600,
                        }}
                    />
                );
            }
        },
    ];

    const actions = [
        {
            id: 'edit',
            icon: 'edit',
            tooltip: 'Editar Usuario',
            onClick: (actionId, row) => history.push(`/Catalogo/Usuario/${row.id}`)
        }
    ];

    return (
        <div className="w-full">
            <DataTable
                columns={columns}
                data={data}
                loading={loading}
                actions={actions}
                hasMore={hasMore}
                page={tableState.page}
                limit={tableState.limit}
                onPageChange={tableState.handlePageChange}
                onLimitChange={tableState.handleLimitChange}
                orderBy={tableState.orderBy}
                order={tableState.order}
                onSort={tableState.handleSort}
                filters={tableState.filters}
                onFilterChange={tableState.handleFilterChange}
                onRowClick={(row) => history.push(`/Catalogo/Usuario/${row.id}`)}
            />
        </div>
    );
};

export default Usuarios;
